(function () {
  function safeParseJSON(text, fallback) {
    try {
      return JSON.parse(text);
    } catch (err) {
      return fallback;
    }
  }

  function escapeHtml(value) {
    return String(value || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function normalizeSku(value) {
    return String(value || "").trim().toUpperCase();
  }

  function splitSkuText(value) {
    return String(value || "")
      .split(/[#,\n\r\t;| ]+/)
      .map(function (part) {
        return decodeURIComponent(part || "").trim();
      })
      .filter(Boolean);
  }

  function extractSkusFromUrl(rawUrl) {
    var url;

    try {
      url = new URL(rawUrl || window.location.href);
    } catch (err) {
      return [];
    }

    var tokens = [];
    var queryKeys = [
      "sku",
      "model",
      "mode",
      "skus",
      "models",
      "modes",
      "sku[]",
      "model[]",
      "mode[]",
      "skus[]",
      "models[]",
      "modes[]"
    ];

    queryKeys.forEach(function (key) {
      var values = url.searchParams.getAll(key);
      values.forEach(function (val) {
        if (val) {
          tokens = tokens.concat(splitSkuText(val));
        }
      });
    });

    var hashText = decodeURIComponent((url.hash || "").replace(/^#/, ""));
    if (hashText) {
      tokens = tokens.concat(splitSkuText(hashText));
    }

    var seen = new Set();
    var result = [];

    tokens.forEach(function (sku) {
      var norm = normalizeSku(sku);
      if (!norm || seen.has(norm)) return;
      seen.add(norm);
      result.push(sku);
    });

    return result;
  }

  function formatMoney(cents, format) {
    var value = Number(cents || 0) / 100;
    var moneyFormat = String(format || "{{amount}}");

    function withDelimiters(number, precision, thousands, decimal) {
      var rounded = Number(number || 0).toFixed(precision);
      var parts = rounded.split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }

    var replacements = {
      "{{amount}}": withDelimiters(value, 2, ".", ","),
      "{{ amount }}": withDelimiters(value, 2, ".", ","),
      "{{amount_no_decimals}}": withDelimiters(value, 0, ".", ","),
      "{{ amount_no_decimals }}": withDelimiters(value, 0, ".", ","),
      "{{amount_with_comma_separator}}": withDelimiters(value, 2, ".", ","),
      "{{ amount_with_comma_separator }}": withDelimiters(value, 2, ".", ",")
    };

    var rendered = moneyFormat;
    Object.keys(replacements).forEach(function (token) {
      rendered = rendered.replace(token, replacements[token]);
    });

    return rendered;
  }

  function setStatus(statusEl, text, type) {
    if (!statusEl) return;
    statusEl.textContent = text || "";
    statusEl.classList.remove("is-error", "is-success");
    if (type) statusEl.classList.add(type);
  }

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.vcartReady === "true") return;
    sectionEl.dataset.vcartReady = "true";

    var productsEl = sectionEl.querySelector("[data-vcart-products]");
    var gridEl = sectionEl.querySelector("[data-vcart-grid]");
    var summaryEl = sectionEl.querySelector("[data-vcart-summary]");
    var statusEl = sectionEl.querySelector("[data-vcart-status]");
    var addBtn = sectionEl.querySelector("[data-vcart-add]");
    var originalAddText = addBtn ? addBtn.textContent : "Sepete Ekle";

    if (!productsEl || !gridEl || !summaryEl || !statusEl || !addBtn) return;

    var products = safeParseJSON((productsEl.textContent || "").trim(), []);
    if (!Array.isArray(products)) products = [];

    var moneyFormat = sectionEl.dataset.moneyFormat || "{{amount}}";
    var hideUnavailable = sectionEl.dataset.hideUnavailable === "true";
    var redirectToCheckout = sectionEl.dataset.redirectToCheckout === "true";
    var emptyUrlMessage = sectionEl.dataset.emptyUrlMessage || "URL icinde SKU bulunamadi.";
    var missingSkuMessage = sectionEl.dataset.missingSkuMessage || "Bazi SKU'lar koleksiyonda bulunamadi";
    var noMatchMessage = sectionEl.dataset.noMatchMessage || "URL'deki SKU'lar ile koleksiyon urunleri eslesmedi.";
    var addErrorMessage = sectionEl.dataset.addErrorMessage || "Sepete eklenirken bir hata olustu.";
    var addSuccessMessage = sectionEl.dataset.addSuccessMessage || "Urunler sepete eklendi.";
    var addingText = sectionEl.dataset.addingText || "Ekleniyor...";

    var skuToProduct = new Map();
    products.forEach(function (item) {
      var norm = normalizeSku(item.sku);
      if (!norm) return;

      if (hideUnavailable && !item.available) return;

      if (!skuToProduct.has(norm)) {
        skuToProduct.set(norm, item);
        return;
      }

      var current = skuToProduct.get(norm);
      if (!current.available && item.available) {
        skuToProduct.set(norm, item);
      }
    });

    var parsedSkus = extractSkusFromUrl(window.location.href);

    if (!parsedSkus.length) {
      addBtn.disabled = true;
      summaryEl.textContent = "0 urun";
      setStatus(statusEl, emptyUrlMessage, "is-error");
      gridEl.innerHTML = "";
      return;
    }

    var missingSkus = [];
    var selectedByVariant = new Map();

    parsedSkus.forEach(function (rawSku) {
      var norm = normalizeSku(rawSku);
      var matched = skuToProduct.get(norm);

      if (!matched) {
        missingSkus.push(rawSku);
        return;
      }

      var variantId = Number(matched.variantId);
      if (!variantId) {
        missingSkus.push(rawSku);
        return;
      }

      if (!selectedByVariant.has(variantId)) {
        selectedByVariant.set(variantId, {
          data: matched,
          quantity: 1,
          requestedSku: rawSku
        });
      } else {
        var current = selectedByVariant.get(variantId);
        current.quantity += 1;
      }
    });

    var selectedItems = Array.from(selectedByVariant.values());

    function renderGrid() {
      if (!selectedItems.length) {
        gridEl.innerHTML = "";
        summaryEl.textContent = "0 urun";
        addBtn.disabled = true;
        setStatus(statusEl, noMatchMessage, "is-error");
        return;
      }

      var totalProducts = selectedItems.reduce(function (sum, item) {
        return sum + item.quantity;
      }, 0);

      var totalPrice = selectedItems.reduce(function (sum, item) {
        return sum + (Number(item.data.priceCents || 0) * item.quantity);
      }, 0);

      summaryEl.innerHTML =
        totalProducts +
        " urun • Toplam: <strong>" +
        formatMoney(totalPrice, moneyFormat) +
        "</strong>";

      addBtn.disabled = false;

      gridEl.innerHTML = selectedItems
        .map(function (item) {
          var p = item.data;
          var hasCompare = Number(p.compareAtPriceCents || 0) > Number(p.priceCents || 0);

          return (
            '<article class="vcart__card">' +
            (p.image
              ? '<img class="vcart__card-image" src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.productTitle) + '" loading="lazy">'
              : '<div class="vcart__card-image"></div>') +
            '<div class="vcart__card-body">' +
            '<h3 class="vcart__card-title">' + escapeHtml(p.productTitle) + "</h3>" +
            '<p class="vcart__card-sku">SKU: ' + escapeHtml(p.sku || item.requestedSku) + "</p>" +
            '<div class="vcart__card-price">' +
            '<span class="vcart__card-price-current">' + formatMoney(p.priceCents, moneyFormat) + "</span>" +
            (hasCompare
              ? '<span class="vcart__card-price-compare">' + formatMoney(p.compareAtPriceCents, moneyFormat) + "</span>"
              : "") +
            "</div>" +
            '<span class="vcart__badge">Adet: ' + item.quantity + "</span>" +
            "</div>" +
            "</article>"
          );
        })
        .join("");

      if (missingSkus.length) {
        setStatus(
          statusEl,
          missingSkuMessage + ": " + missingSkus.join(", "),
          "is-error"
        );
      } else {
        setStatus(statusEl, "", "");
      }
    }

    async function addToCart() {
      if (!selectedItems.length) return;

      addBtn.disabled = true;
      addBtn.textContent = addingText;
      setStatus(statusEl, "", "");

      var items = selectedItems.map(function (item) {
        return {
          id: Number(item.data.variantId),
          quantity: Number(item.quantity)
        };
      });

      try {
        var response = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items: items })
        });

        if (!response.ok) {
          throw new Error("cart_add_failed");
        }

        setStatus(statusEl, addSuccessMessage, "is-success");
        window.location.href = redirectToCheckout ? "/checkout" : "/cart";
      } catch (error) {
        setStatus(statusEl, addErrorMessage, "is-error");
        addBtn.disabled = false;
        addBtn.textContent = originalAddText;
      }
    }

    addBtn.addEventListener("click", addToCart);
    renderGrid();
  }

  function initAll() {
    document.querySelectorAll(".vcart[data-section-id]").forEach(initSection);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("shopify:section:load", function (event) {
    initSection(event.target);
  });
})();
